<template>
  <div class="category-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input v-model="searchParams.categoryNameLike" :placeholder="$t('shop.categoryNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%" class="margin-top">
      <el-table-column prop="shopName" label="店铺" align="center"></el-table-column>
      <el-table-column prop="categoryId" label="分类编号" align="center"></el-table-column>
      <el-table-column prop="categoryName" label="分类名称" align="center"></el-table-column>
      <el-table-column prop="cateTypeName" label="分组目录" align="center"></el-table-column>
      <el-table-column prop="seq" label="显示序号" align="center"></el-table-column>
      <el-table-column prop="isShow" label="是否显示" align="center">
        <template #default="scope">
          {{ scope.row.isShow === 'Y' ? $t('common.yes') : $t('common.no') }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
    </el-table>

    <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { getCategoryList } from '@/api/shop/shopApi'

export default {
  name: 'AShopDetailCategory',
  data() {
    return {
      searchParams: {
        categoryNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          categoryNameLike: this.searchParams.categoryNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }

        const res = await getCategoryList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取分类列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.category-container {
  padding: 20px;
}

.search-row {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}
</style>